module.exports = __webpack_public_path__ + "img/Tangling Chain.f0b512f4.png";